export const getError = (error) => {
    if (!error.response) {
        console.error("[Network Error]", error.message, error);
        return "Chyba sítě";
    }
    const status = error.response.status;
    const serverMessage = error.response.data?.message;

    if (status >= 400 && status < 500 && serverMessage) {
        console.error("[Client Error]", status, serverMessage, error);
        return serverMessage;
    }

    console.error("[Server Error]", status, serverMessage, error);
    return "Chyba serveru";
};

export const getDate = (time) => {
    return (new Date(time).getDate()) + "." + (new Date(time).getMonth() + 1) + "." + new Date(time).getFullYear();
};